import {useContext} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MoleculeStepper, {moleculeStepperDesign} from '@s-ui/react-molecule-stepper'
import GalleryBasic, {COUNTER_POSITIONS} from '@adv-mt/mt-gallery-basic'
import LockOutline from '@adv-mt/mt-svg-icons/lib/CarSecurityOutline'
import CreditCardIcon from '@adv-mt/mt-svg-icons/lib/CreditCardOutline'
import ShieldCheckOutline from '@adv-mt/mt-svg-icons/lib/ShieldCheckOutline.js'

const BASE_CLASS = 'mt-DrawerReservationInitialization'

export const ReservationInfoRevamp = ({adInfo, logoThirdParty}) => {
  const {i18n} = useContext(Context)

  const {title, imageUrl, images: allImages, year, km, fuelType} = adInfo
  const images = allImages?.slice(0, 5)

  const vehicleDetails = [year, km ? `${km.toLocaleString()} km` : null, fuelType].filter(Boolean).join(' · ')

  return (
    <div className={`${BASE_CLASS}-infoRevamp`}>
      <div className={`${BASE_CLASS}-stepper`}>
        <p className={`${BASE_CLASS}-stepperLabel`}>{i18n.t('VEHICLE_RESERVATION.MODAL_ONBOARDING.STEP_LABEL')}</p>
        <MoleculeStepper design={moleculeStepperDesign.COMPRESSED} showLabel={false} step={1} steps={2} />
      </div>
      {(images?.length > 0 || imageUrl) && (
        <div className={`${BASE_CLASS}-imageWrapper`}>
          {images?.length > 1 ? (
            <GalleryBasic
              images={images.map((src, index) => ({src, alt: `${title} ${index + 1}`}))}
              showThumbnails={false}
              enableCounter
              counterPosition={COUNTER_POSITIONS.bottomLeft}
            />
          ) : (
            <AtomImage alt={title} src={images?.[0] ?? imageUrl} />
          )}
        </div>
      )}
      <div className={`${BASE_CLASS}-vehicleInfo`}>
        <p className={`${BASE_CLASS}-vehicleName`}>{title}</p>
        {vehicleDetails && <p className={`${BASE_CLASS}-vehicleDetails`}>{vehicleDetails}</p>}
      </div>
      <ul className={`${BASE_CLASS}-benefits`}>
        <li className={`${BASE_CLASS}-benefitItem`}>
          <div className={`${BASE_CLASS}-benefitIcon`}>
            <ShieldCheckOutline size={ATOM_ICON_SIZES.medium} />
          </div>
          <div className={`${BASE_CLASS}-benefitContent`}>
            <p className={`${BASE_CLASS}-benefitTitle`}>
              {i18n.t('VEHICLE_RESERVATION.MODAL_ONBOARDING.BENEFIT_REFUND_TITLE')}
            </p>
            <p className={`${BASE_CLASS}-benefitSubtitle`}>
              {i18n.t('VEHICLE_RESERVATION.MODAL_ONBOARDING.BENEFIT_REFUND_SUBTITLE')}
            </p>
          </div>
        </li>
        <li className={`${BASE_CLASS}-benefitItem`}>
          <div className={`${BASE_CLASS}-benefitIcon`}>
            <LockOutline size={ATOM_ICON_SIZES.medium} />
          </div>
          <div className={`${BASE_CLASS}-benefitContent`}>
            <p className={`${BASE_CLASS}-benefitTitle`}>
              {i18n.t('VEHICLE_RESERVATION.MODAL_ONBOARDING.BENEFIT_RESERVED_TITLE')}
            </p>
            <p className={`${BASE_CLASS}-benefitSubtitle`}>
              {i18n.t('VEHICLE_RESERVATION.MODAL_ONBOARDING.BENEFIT_RESERVED_SUBTITLE')}
            </p>
          </div>
        </li>
        <li className={`${BASE_CLASS}-benefitItem`}>
          <div className={`${BASE_CLASS}-benefitIcon`}>
            <CreditCardIcon size={ATOM_ICON_SIZES.medium} />
          </div>
          <div className={`${BASE_CLASS}-benefitContent`}>
            <div className={`${BASE_CLASS}-benefitTitleRow`}>
              <p className={`${BASE_CLASS}-benefitTitle`}>
                {i18n.t('VEHICLE_RESERVATION.MODAL_ONBOARDING.BENEFIT_PAYMENT_TITLE')}
              </p>
              <div className={`${BASE_CLASS}-benefitPaymentIcons`}>
                <img
                  className={`${BASE_CLASS}-benefitPaymentIconCards`}
                  src={logoThirdParty}
                  alt="apple pay google pay mastercard visa"
                />
              </div>
            </div>
            <p className={`${BASE_CLASS}-benefitSubtitle`}>
              {i18n.t('VEHICLE_RESERVATION.MODAL_ONBOARDING.BENEFIT_PAYMENT_SUBTITLE')}
            </p>
          </div>
        </li>
      </ul>
    </div>
  )
}

ReservationInfoRevamp.displayName = 'ReservationInfoRevamp'
ReservationInfoRevamp.propTypes = {
  adInfo: PropTypes.object,
  logoThirdParty: PropTypes.string
}
